

import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom";
import CountryFlagAndName from '../../components/countryFlagAndName.js'
import FlashMessages, {FlashMessageData} from '../../components/flashMessages.js';
//import DomainReference from '../../components/domainReference.js'
import {_printDate, _printShortFullDate, _printNumber} from '../../helpers/helpers.js'
import imageOnError from '../../helpers/imgOnError.js';


import {APIResponse} from '../../../../server/routes/route-types.js'
import {RtApiDeleteResponse, RtMonitoredWebsiteInfo, RtMonitoringWebsitesPageResult} from '../../../../server/routes/monitoring.js'
//

// interface MonitoredWebsite {
// 	Website: string;
// 	MonitorTechnologies: boolean;
// 	MonitorSecurity: boolean;
// 	Added: string;
// 	LastScanned?: string;
// }

// interface FlashState {
// 	errors?: string | null;
// 	success_msg?: string | null;
// 	error_msg?: string | null;
// 	error?: string | null;
// }

// interface ApiDeleteResponse {
// 	err?: string;
// 	results?: {
// 		status: string;
// 	};
// }

// interface MonitoringWebsitesPageData {
// 	MonitoredWebsites: MonitoredWebsite[];
// 	MonitoredWebsitesCount: number;
// 	MaxMonitoredWebsitesCount: number;
// }

interface MonitoringWebsitesProps {
	server: string;
	pageData: unknown;
}

export default function MonitoringWebsites({pageData}: MonitoringWebsitesProps) {

	let [data, setData] = useState(pageData as RtMonitoringWebsitesPageResult);

	const initialFlashProps: FlashMessageData = {
		success_msg: `You have used ${data.MonitoredWebsitesCount} out of the ${data.MaxMonitoredWebsitesCount} websites allowed by your subscription.`,
	}

	const [flashProps, setFlashProps] = useState<FlashMessageData>(initialFlashProps);
	const [selectedDomain, setSelectedDomain] = useState<string>('');

	interface MonitoredDomainTableProps {
		domainList: RtMonitoredWebsiteInfo[];
	}

	function MonitoredDomainTable({domainList}: MonitoredDomainTableProps) {
		if (!domainList) return (<></>);
		if (!domainList.length) return (
			<>
				<p>
				The monitoring list is empty
				</p>
				<p>
					<ul>
						<li>
							<Link 
								target="_blank" 
								to={`/monitoring/sample`}
								className="link-hover" 
								title={`Sample Monitoring Report`} 
							>
								Sample Monitoring Report&nbsp;
								<span className="icon text-right fa fa-external_link"></span>
							</Link>							
						</li>
						<li>
							<Link 
								target="_blank" 
								to={`/monitoring/sample-notification-email`}
								className="link-hover" 
								title={`Example Monitoring Notification Email`} 
							>
								Example Monitoring Notification Email&nbsp;
								<span className="icon text-right fa fa-external_link"></span>
							</Link>							
						</li>
						</ul>		
					</p>
			</>
		);
	
		return (
			<>
			
				<div className="table-outer table-rounded table-responsive-lg">
				<table className="table-custom table-custom-striped table-custom-primary  ">
					<thead>
					<tr>			
						<th style={{width: '30%'}}>Domain</th>
						<th style={{width: '15%'}}>Technology</th>
						<th style={{width: '15%'}}>Security</th>
						<th style={{width: '15%'}}>Added</th>
						<th style={{width: '15%'}}>Last Scan</th>
						<th style={{width: '10%'}}></th>	
					</tr>
					</thead>
						<tbody>
							{
							domainList.map((domain, indexKey) => {
								return (
									<DomainRow domain={domain} key={indexKey} />
								)
							})
						}	
					</tbody>
				</table>	
				</div>
	
			</>
		)
	}
	
	interface DomainRowProps {
		domain: RtMonitoredWebsiteInfo;
	}

	function DomainRow({domain}: DomainRowProps) {

		if (domain === undefined || domain.Website === undefined) return (<></>);

		const d = domain.Website.trim();
	
		return (
	
			<>
				<tr>		
					<td>
						<MonitoredDomainReference 
							domain={d} 
							openProtocol={'https'} 
							title={`${domain.Website} information and technology stack`}
						/>
					</td>
					<td>{domain.MonitorTechnologies ? 'Monitored' : '-'} </td>				
					<td>{domain.MonitorSecurity ? 'Monitored' : '-'} </td>
					<td>{_printShortFullDate(domain.Added)} </td>
					<td>{domain.LastScanned ? _printShortFullDate(domain.LastScanned) : '-'} </td>
					<td>
						<button 
							type="button" 
							className="btn btn-danger" 
							data-toggle="modal" 
							data-domain={d}
							data-target="#modalConfirm"
							onClick = {(event) => setSelectedDomain( d ) }
						>
							X
						</button>
					</td>	
				</tr>		
			</>
		)
	}

	function handleDeleteClick(event: React.MouseEvent<HTMLButtonElement>): void {
		var domain = selectedDomain;	
		event.preventDefault();
	
//		console.log(JSON.stringify(domain));

	// http://localhost:3001/monitoring/api-delete-website?website=webtechsurvey.com
	
		fetch( `/monitoring/api-delete-website?website=${domain}`, {
			method: "GET",
			body: null
		}).then(( response ) => {
			return response.json();
		}).then(( data: APIResponse<RtApiDeleteResponse> ) => {
			console.log(data);
	
			if (data.err) {
				setFlashProps({error_msg: data.err})
			}
			else
			{
				if (data.results?.status === 'success') {
					setFlashProps({success_msg: 'The website has been removed from the monitored list.'} );
					window.location.href = window.location.href;
				} else {
					setFlashProps({error_msg: 'Unexpected error'})
				}
			}
		}).catch(( e ) => {
			setFlashProps({error: 'Unexpected error'});
		});
	}
	
	function ConfirmDeleteAccountModal() {
		return (<>
			<div className="modal fade" id="modalConfirm" tabIndex={-2} role="dialog" aria-labelledby="modalConfirmLabel" aria-hidden="true">
				<div className="modal-dialog modal-dialog-centered" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title" id="modalConfirmLabel">Please Confirm</h5>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div className="modal-body">
							Are you sure you want to delete the website from monitoring list? Once website is deleted all the change history is lost.
						</div>
						<div className="modal-footer">
							<button 
								type="button" 
								className="btn btn-primary" 
								data-dismiss="modal" 
								id="btn-delete-account"
								onClick={(event) => handleDeleteClick(event)}>Delete Website</button>
							<button type="button" className="btn btn-secondary" data-dismiss="modal">Cancel</button>
						</div>
					</div>
				</div>
			</div>
		</>)    
	}
	
	

	return (
		<>      
			<h3>Monitored Websites</h3>
			Websites monitored for technology and security changes

			<div className="row row-50">
				<div className="col-md-12 col-lg-12 col-xl-12">
				<FlashMessages props={flashProps} />
				<ConfirmDeleteAccountModal />
				<MonitoredDomainTable domainList={data.MonitoredWebsites} />			
				</div>	          
			</div>


			<div className="row row-50">
				<div className="col-md-12 col-lg-12 col-xl-12">
					<Link 
						className="btn btn-primary" 
						title='Monitored Websites list'
						to={'/monitoring/add-website'}
						style={{ marginLeft: "auto", float: 'right' }} 
					>
					Add website
					</Link>					
			</div>	
			</div>	
			<br/>
			<br/>	
		</>
	)
};




interface MonitoredDomainReferenceProps {
	domain: string;
	openProtocol: string;
	title?: string;
}

function MonitoredDomainReference({domain, openProtocol, title}: MonitoredDomainReferenceProps) {

	// if title not defined ... use default title
	const realTitle: string = 
		(title && title.length > 0) ? 
			title :
			`${domain} technology stack and statistics`;


	return (
		<>
			<img 
				src={`https://www.google.com/s2/favicons?domain=${domain}`} 
				onError={imageOnError}       
				width="16"
				height="16"
			/>
			<Link 
				className="link-hover word-break" 
				title={realTitle} 
				to={`/monitoring/${domain}`}
			>
				{' '}{domain}{' '}
			</Link>
			<a
				target="_blank" 
				rel="noopener nofollow noreferrer" 
				href={`${openProtocol}://${domain}/`}
			>
				<span className="icon text-right fa fa-external_link"></span>
			</a>
		</>
	)
}
